export default [
    {
      path: '/b/daftar-bmd',
      redirect: '/b/daftar-bmd',
      name: 'bDaftarBmd',
      component: () => import('@/views/NestedRoute.vue'),
      children: [
        {
          path: '',
          name: 'bDaftarBmdIndex',
          component: () => import('@/views/b/daftarBmd/Index.vue'),
          meta: {
            action: 'Lihat',
            resource: 'b-daftar-bmd',
            pageTitle: 'Daftar BMD ',
            breadcrumb: [
              {
                text: 'Daftar BMD',
                active: true,
              },
            ],
          },
        },
      ],
    },
  ]
  